import { useQuery } from '@apollo/client'
import { GetJobCatalogPeopleInsightsDocument } from 'generated/resources/graphql'

import type { PeopleInsightsData } from 'modules/job_catalog/lib/peopleInsights'

export type {
  PeopleInsightsData,
  PeopleInsightsGroup,
} from 'modules/job_catalog/lib/peopleInsights'

export const usePeopleInsights = (
  nodeUuid: string,
  skip = false
): { data: PeopleInsightsData | null; loading: boolean } => {
  const { data, loading } = useQuery(GetJobCatalogPeopleInsightsDocument, {
    variables: { nodeUuid },
    skip: skip || !nodeUuid,
  })

  const node = data?.jobCatalog?.peopleInsightsConnection?.nodes?.[0]
  if (!node) return { data: null, loading }

  return {
    data: {
      totalCount: node.totalCount ?? 0,
      maleCount: node.maleCount ?? 0,
      femaleCount: node.femaleCount ?? 0,
      notDeclaredCount: node.notDeclaredCount ?? 0,
      groups: (node.groups ?? []).map((g) => ({
        nodeGroupId: g.nodeGroupId,
        nodeGroupName: g.nodeGroupName,
        maleCount: g.maleCount ?? 0,
        femaleCount: g.femaleCount ?? 0,
        notDeclaredCount: g.notDeclaredCount ?? 0,
      })),
    },
    loading,
  }
}
